import type { CityConfig } from "../city-template/types";

export const sammamishConfig: CityConfig = {
  city: "Sammamish",
  state: "Washington",
  stateAbbr: "WA",
  slug: "sammamish",
  route: "/cities/sammamish",
  title: "Emergency Passport Sammamish WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Sammamish, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Sammamish, Issaquah, Klahanie, and all Sammamish Plateau residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Sammamish, WA",
  heroSubtitle: "Sammamish travelers — from tech executives on the Issaquah Plateau to waterfront families on Lake Sammamish to Eastside professionals in one of Washington's fastest-growing cities — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of the Sammamish Plateau and eastern King County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Sammamish%20Washington%20on%20the%20Issaquah%20Plateau%20with%20Lake%20Sammamish%20in%20the%20foreground%2C%20the%20Cascade%20Mountains%20rising%20in%20the%20distance%2C%20upscale%20residential%20neighborhoods%20with%20Pacific%20Northwest%20evergreen%20canopy%2C%20modern%20suburban%20golf%20course%20communities%2C%20Marymoor%20Park%20and%20Sammamish%20River%20Valley%2C%20warm%20golden%20afternoon%20light%20over%20the%20Eastside%20plateau%2C%20fast-growing%20tech%20community%20atmosphere%2C%20professional%20photography%20without%20text%20or%20people&width=1800&height=700&seq=sammamish-hero-001&orientation=landscape",
  heroImageAlt: "Sammamish Washington Sammamish Plateau with Lake Sammamish and Cascade Mountains",
  geoPosition: "47.6062;-122.0321",
  geoPlacename: "Sammamish, Washington",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "Approximately 20 miles west of Sammamish via I-90",
  },
  nearbyCitiesZips: [
    { name: "Sammamish", zips: "98074, 98075" },
    { name: "Issaquah", zips: "98027, 98029, 98075" },
    { name: "Redmond", zips: "98052, 98053, 98073" },
    { name: "Bellevue", zips: "98004, 98005, 98006, 98007, 98008" },
    { name: "Kirkland", zips: "98033, 98034, 98083" },
    { name: "Klahanie", zips: "98075" },
    { name: "Pine Lake", zips: "98075" },
    { name: "Beaver Lake", zips: "98075" },
    { name: "Plateau", zips: "98075" },
    { name: "Fall City", zips: "98024" },
    { name: "Snoqualmie", zips: "98065" },
    { name: "North Bend", zips: "98045" },
    { name: "Preston", zips: "98050" },
    { name: "Mirrormont", zips: "98027" },
    { name: "Newcastle", zips: "98056, 98059" },
    { name: "Renton", zips: "98055, 98056, 98057, 98058, 98059" },
    { name: "Duvall", zips: "98019" },
    { name: "Carnation", zips: "98014" },
    { name: "Woodinville", zips: "98072, 98077" },
    { name: "Clyde Hill", zips: "98004" },
    { name: "Medina", zips: "98039" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 20 minutes west via I-90" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Sammamish Plateau Hub", desc: "One of WA's fastest-growing cities — serving tech families, Issaquah, and the Eastside" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Sammamish or Issaquah location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Bellevue, WA", route: "/cities/bellevue" },
    { name: "Emergency passport help in Redmond, WA", route: "/cities/redmond-wa" },
    { name: "Urgent passport services in Kirkland, WA", route: "/cities/kirkland" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Sammamish, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — approximately 20 minutes west via I-90. Sammamish residents can ship from any UPS or FedEx on the Eastside.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Sammamish, Issaquah, Klahanie, Fall City, Snoqualmie, North Bend, and all of the Sammamish Plateau and Snoqualmie Valley",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Sammamish and the Sammamish Plateau. From the residential communities around Lake Sammamish to the golf course neighborhoods, from the growing tech families of Klahanie and the Plateau to the scenic Snoqualmie Valley below — we serve all of Sammamish and eastern King County.",
  nearbyCitiesIntro: "We serve Sammamish and all nearby communities including Issaquah, Redmond, Bellevue, Kirkland, Klahanie, Fall City, Snoqualmie, North Bend, and Preston. We also serve the Eastside tech corridor and the Snoqualmie Valley communities.",
  howItWorksIntro: "Most Sammamish travelers complete everything online and ship documents overnight. No need to drive 20 minutes west on I-90 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Sammamish is one of Washington's fastest-growing cities and a premier address for tech executives and families on the Eastside. Here are the most common passport mistakes we see from Sammamish Plateau travelers.",
  testimonialsIntro: "Sammamish travelers — from tech executives to Eastside families to Sammamish Plateau residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Sammamish, WA? Here are the most common ones we hear from Sammamish Plateau travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive across Lake Washington to Seattle", "I-90 bridge and downtown parking"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close Eastside proximity via I-90", "No downtown parking or Seattle traffic", "Perfect for tech executives and Eastside families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close Eastside proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Sammamish travelers with immediate departure needs — as fast as 24 hours. Our couriers handle the Seattle agency delivery. Perfect for Eastside tech travel, executive family vacations, and last-minute international departures.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — I-90 corridor courier", "Tech executive and Eastside family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Sammamish adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Sammamish Plateau address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Sammamish residents and families — including Eastside tech families, Plateau residents, and newcomers to Washington's fastest-growing city.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Sammamish residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Sammamish and Eastside families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Sammamish and Eastside residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Sammamish WA", description: "Urgent passport processing for Sammamish Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Sammamish WA", description: "Fast passport renewal for Sammamish Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Sammamish WA", description: "New passport application services for Sammamish Washington residents applying for their first passport." },
    { name: "Child Passport Sammamish WA", description: "Minor passport services for Sammamish Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Vikram S.",
      location: "Sammamish, WA",
      rating: 5,
      text: "Microsoft offsite in London with 5 days notice and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store in Issaquah and the whole process was seamless. Outstanding for the Plateau.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jennifer & Michael L.",
      location: "Klahanie, WA",
      rating: 5,
      text: "Family trip to Japan with 10 days notice. Four passports — two adult renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx in Sammamish and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Robert K.",
      location: "Sammamish, WA",
      rating: 5,
      text: "Business trip to Sydney with 8 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. Not having to drive across the I-90 bridge to Seattle was a game changer.",
      service: "Emergency Passport",
    },
    {
      name: "Catherine W.",
      location: "Issaquah, WA",
      rating: 5,
      text: "Lost my passport two weeks before a conference in Paris. Fast Passport Center replaced it in 4 days. As a relocated Microsoft family on the Plateau, this kind of service is exactly what Eastside professionals need.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "sam-1",
      name: "Sammamish Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "22424 SE 4th St",
      city: "Sammamish",
      state: "WA",
      zip: "98074",
      phone: "(425) 868-9023",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Sammamish, near the Sammamish Plateau",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Sammamish acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Sammamish, Klahanie, and the Plateau communities.",
      icon: "ri-mail-line",
    },
    {
      id: "sam-2",
      name: "Issaquah Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "250 NE Mulberry St",
      city: "Issaquah",
      state: "WA",
      zip: "98027",
      phone: "(425) 392-5360",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Issaquah, approximately 5 miles south of downtown Sammamish",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Issaquah, south Sammamish, and Mirrormont residents. Near the Issaquah Highlands and Gilman Village areas.",
      icon: "ri-mail-line",
    },
    {
      id: "sam-3",
      name: "Redmond Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7241 185th Ave NE",
      city: "Redmond",
      state: "WA",
      zip: "98052",
      phone: "(425) 885-1121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Redmond, approximately 8 miles north of downtown Sammamish",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Redmond, Microsoft campus, and north Sammamish residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "sam-4",
      name: "Bellevue Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1801 136th Pl NE",
      city: "Bellevue",
      state: "WA",
      zip: "98005",
      phone: "(425) 462-0125",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bellevue, approximately 12 miles west of Sammamish",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest Eastside facility. Good alternative for the west Sammamish area. More appointment availability than Plateau offices.",
      icon: "ri-mail-line",
    },
    {
      id: "sam-5",
      name: "King County Clerk — Seattle",
      type: "County Clerk Passport Acceptance",
      address: "516 3rd Ave, Room W-105",
      city: "Seattle",
      state: "WA",
      zip: "98104",
      phone: "(206) 477-3080",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Seattle Courthouse — approximately 20 minutes via I-90",
      website: "https://www.kingcounty.com/depts/courts/clerk.aspx",
      websiteLabel: "King County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Sammamish residents may prefer the Sammamish, Issaquah, or Redmond post offices for convenience.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — I-90 bridge to downtown Seattle", fpc: "No — ship from Sammamish" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Plateau Tech Advantage", agency: "No special guidance", fpc: "Yes — Eastside executive and family travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Sammamish tech executives and Eastside families often discover passport issues just before international conferences and luxury vacations. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services at the Sammamish Highlands or Issaquah Commons sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at King County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Sammamish Post Office appointments fill during summer family travel and tech conference seasons. Book 2–3 weeks ahead — the Plateau is a high-demand area.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the I-90 Bridge in Rush Hour",
      description: "Sammamish residents are 20 minutes from Seattle — but that can easily become 45+ during rush hour. Between the I-90 floating bridge, downtown parking, and Seattle traffic, an 'easy morning errand' becomes a half-day commitment. Our courier service means you never deal with any of it.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. As Washington's fastest-growing city, Sammamish has consistently high passport demand — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere on the Sammamish Plateau." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Sammamish, Issaquah, or Redmond." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to cross the I-90 bridge yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Sammamish address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Sammamish, WA?", a: "Fast Passport Center offers emergency passport processing in Sammamish, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — approximately 20 minutes west via I-90." },
    { q: "Does Sammamish have its own passport agency?", a: "No — Sammamish does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 20 minutes west via I-90). Fast Passport Center's courier service means Sammamish residents never need to deal with I-90 bridge traffic and downtown Seattle parking." },
    { q: "Can I get an expedited passport in Issaquah, Klahanie, or Fall City?", a: "Absolutely. Fast Passport Center serves all of the Sammamish Plateau including Issaquah, Klahanie, Fall City, Snoqualmie, North Bend, and all surrounding communities. Our service works the same way everywhere." },
    { q: "What airport do Sammamish travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport — approximately 30 minutes via I-90. SEA offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Always verify passport validity for at least 6 months past your return date." },
    { q: "Why is Sammamish one of the fastest-growing cities in Washington?", a: "Sammamish's combination of top-ranked schools, Lake Sammamish access, spacious homes on the Issaquah Plateau, and proximity to Microsoft, Amazon, and Google campuses has made it a premier destination for tech families. This rapid growth also means consistently high demand for passport services — our courier service helps meet that demand." },
    { q: "How much does an expedited passport cost in Sammamish, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Sammamish?", a: "Walgreens, CVS, and Bartell Drugs stores throughout Sammamish and Issaquah offer passport photos. UPS Store and FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve tech executives on the Sammamish Plateau?", a: "Yes. Fast Passport Center serves all Eastside communities including the Sammamish Plateau, home to a high concentration of Microsoft, Amazon, and Google executives. We understand the demanding schedules and urgent international travel needs of Eastside tech professionals. Our courier service means you never need to take time away from work to drive to Seattle." },
  ],
  photoLocations: [
    { name: "Walgreens — Issaquah Highlands", address: "1000 NE Park Dr, Issaquah, WA 98029", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Bartell Drugs — Sammamish", address: "22636 SE 4th St, Sammamish, WA 98074", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Sammamish Highlands", address: "4420 228th Ave SE, Sammamish, WA 98075", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Bellevue", address: "10600 NE 8th St, Bellevue, WA 98004", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Issaquah", address: "3707 Providence Point Dr SE, Issaquah, WA 98029", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Closest Washington Department of Licensing office to Sammamish. Driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Bellevue", address: "13133 NE 20th St, Bellevue, WA 98005", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Bellevue and west Sammamish. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "30 minutes from Sammamish via I-90",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Sammamish and the Eastside. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. I-90 provides direct access from the Sammamish Plateau to SEA.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "BFI",
      name: "King County International Airport (Boeing Field)",
      distance: "Approximately 25 minutes via I-90",
      address: "7277 Perimeter Rd S, Seattle, WA 98108",
      note: "General aviation and cargo airport. Not typically used for international passenger travel. Serves Boeing and corporate aviation.",
      flightUrl: "https://www.kingcounty.gov/depts/transportation/kcia.aspx",
      flightLabel: "BFI Info",
      featured: false,
    },
  ],
};